<template>
  <div :class="[schema.fieldName, getSelectedDEV && 'dev-selected-component']">
    <vueper-slides class="no-shadow" v-bind="schema.attributesCarousels">
      <vueper-slide v-for="(slide, i) in schema.items"
        :key="i"
        :image="slide.image"
        :href="slide.image"
      ></vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import { VueperSlides, VueperSlide } from 'vueperslides';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    VueperSlides,
    VueperSlide
  },

  computed: {
    paths() {
      return this.$store.getters['layout/getConfigPaths'];
    }
  },

  mounted() {
    for (let i in this.schema.items) {
      this.schema.items[i].image = this.schema.items[i].image.startsWith('static')
        ? this.schema.items[i].image
        : this.paths[this.schema.items[i].image];
    }
  },
};
</script>
